import {createSelector} from "@reduxjs/toolkit";

const baseState = state => state.user.settings;

const settingsEntries = createSelector([baseState], state => {
    return Object.entries(state.data).map(([key, value]) => ({key, value: !!value}));
});

export const settingsPublicProfile = createSelector([settingsEntries], (data) => {
    return data.filter(i => i.key.startsWith("show_"));
});
export const settingsEmail = createSelector([settingsEntries], (data) => {
    return data.filter(i => i.key.startsWith("email_"));
});
export const settingsOtherPlans = createSelector([settingsEntries], (data) => {
    return data.filter(i => i.key.startsWith("see_"));
});